const processesKeys: string[] = ['user', 'pid', 'cpu', 'mem', 'vsz', 'rss', 'tt', 'stat', 'started', 'command'];

export default processesKeys;
